import type { Role } from "shared"

import type { OtkSubjectResponsiblePerson } from "@/lib/api/subjects"
import type { OtkUser } from "@/lib/api/users"

export type UserTableRow = {
  id: string
  email: string
  responsiblePerson: string
  rnokpp: string
  role: string
  /** Raw roles backing this row, needed to call `/user/:id/add-role` /
   *  `remove-role` from `EditUserDialog` — the flattened `role` display
   *  string alone can't drive those calls. */
  roles: Role[]
  status: string
  note: string
}

function responsiblePersonName(person: OtkSubjectResponsiblePerson): string {
  return [person.prizvyshche, person.imia, person.poBatkovi]
    .filter(Boolean)
    .join(" ")
}

export function createUserTableRows(
  users: OtkUser[],
  responsiblePersons: OtkSubjectResponsiblePerson[],
  roleLabelById: Record<string, string>
): UserTableRow[] {
  return users.map((user) => {
    const responsiblePerson = responsiblePersons.find(
      (person) => person.rnokpp === user.rnokpp
    )

    return {
      id: user.id,
      email: user.email,
      responsiblePerson: responsiblePerson
        ? responsiblePersonName(responsiblePerson)
        : "—",
      rnokpp: user.rnokpp,
      role:
        user.roles.length > 0
          ? user.roles.map((role) => roleLabelById[role] ?? role).join(", ")
          : "—",
      roles: user.roles,
      status: "АКТИВНИЙ",
      note: "",
    }
  })
}
